app.globalController = app.globalController || {};

app.globalController.indexAction = {
    
    /**
     * Initialisation de la fonction
     * @returns {undefined}
     */
    init : function () {
        if (!('ontouchstart' in document.documentElement)) {
            $('html').removeClass('touch').addClass('no-touch');
        }
        else {
            $('html').removeClass('no-touch').addClass('touch');
        }
    }

};